/* 
 * @author Tommy Brière
 * @copyright (c) 2015 Groupe PVP
 * @fileoverview TODO
 */
(function($, $g) {
    "use strict";
    var M = Math;
    
    function computeScaling(w, h, targetW, targetH, minScale) {
        var cfg = $g.cfg;        
        targetW = targetW || cfg.width;
        targetH = targetH || cfg.height;
        minScale = minScale || cfg.minScale;
        
        var sw = w / targetW;
        var sh = h / targetH;
        var scale = M.min(sw, sh);
        scale = M.max(scale, (minScale || 0.2));
        var iscale = 1 / scale;
        var width = w * iscale;
        var height = h * iscale;
        var gapX = (width - targetW) * 0.5;
        var gapY = (height - targetH) * 0.5;

        var r = {
            width: width,
            height: height,
            realWidth: w,
            realHeight: h,
            scale: scale,
            iscale: iscale,
            gapX: gapX,
            gapY: gapY,
            realGapX: gapX * scale,
            realGapY: gapY * scale
        };
        return r;
    }
    
    function ScaledContainer(container) {
        var me = this;
        //var resizeSignal = this.resize = new Signal();

        this.update = function (size) {
            $.extend(me, size);
            var scale = me.scale;
            container.x = me.realGapX;
            container.y = me.realGapY;
            container.scaleX = scale;
            container.scaleY = scale;
            //resizeSignal.trigger(scale);
        };        
    }
    
    $g.ScaledContainer = ScaledContainer;
    $g.computeScaling = computeScaling;
})(jQuery, PVPGEngine);